<template>
  <div>
    <!-- <button  >nihao</button> -->
    <!-- v-model="formValidate.province" -->
    <el-select :class="selectBg" placeholder="Country" filterable v-model="formData">
      <el-option-group
        :class="groupBg"
        v-for="group in country"
        :key="group.label"
        :label="group.label">
        <el-option
          :disabled="item.disabled"
          v-for="item in group.options"
          :key="item.value"
          :label="item.value"
          :value="item.value"
          type="button"
        ></el-option>
      </el-option-group>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "foreignArea",
  props: {
    // title: {
    //   Type: String,
    //   default: ""
    // },

    countryId: {
      type: String,
      default: "America +1"
    },
    selectBg: {
      Type: String,
      default: ""
    },
    groupBg: {
      Type: String,
      default: ""
    },
    popularCity: {
      Type: Object,
      default: null
    },
  },
  data() {
    return {
      formData: '',
      country: [
       /* {
          label: "Popular country",
          options: [this.popularCity]
        },*/
        {
          label: "All country",
          options: [
            { value: "America +1", label: "美国" , disabled: false},
            { value: "China +86", label: "中国" },
            { value: "Angola +244", label: "安哥拉" },
            { value: "Afghanistan +93", label: "阿富汗" },
            { value: "Albania +355", label: "阿尔巴尼亚" },
            { value: "Algeria +213", label: "阿尔及利亚" },
            { value: "Andorra +376", label: "安道尔共和国" },
            { value: "Argentina +54", label: "阿根廷" },
            { value: "Armenia +374", label: "亚美尼亚" },
            { value: "Arabia +966", label: "沙特阿拉伯" },
            { value: "Australia +61", label: "澳大利亚" },
            { value: "Austria +43", label: "奥地利" },
            { value: "Azerbaijan +994", label: "阿塞拜疆" },
            { value: "Bahrain +973", label: "巴林" },
            { value: "Bangladesh +880", label: "孟加拉国" },
            { value: "Belarus +375", label: "白俄罗斯" },
            { value: "Belgium +32", label: "比利时" },
            { value: "Belize +501", label: "伯利兹" },
            { value: "Benin +229", label: "贝宁" },
            { value: "Bhutan +975", label: "不丹" },
            { value: "Bolivia +591", label: "玻利维亚" },
            { value: "Botswana +267", label: "博茨瓦纳" },
            { value: "Brazil +55", label: "巴西" },
            { value: "Brunei +673", label: "文莱" },
            { value: "Bulgaria +359", label: "保加利亚" },
            { value: "Burkina Faso +226", label: "布基纳法索" },
            { value: "Burma +95", label: "缅甸" },
            { value: "Cayman Is +1-345", label: "开曼群岛" },
            { value: "Central African Republic +236", label: "中非共和国" },
            { value: "Chad +235", label: "乍得" },
            { value: "Chile +56", label: "智利" },
            { value: "Colombia +57", label: "哥伦比亚" },
            { value: "Costa Rica +506", label: "哥斯达黎加" },
            { value: "Cuba +53", label: "古巴" },
            { value: "Cyprus +357", label: "塞浦路斯" },
            { value: "Denmark +45", label: "丹麦" },
            { value: "Ecuador +593", label: "厄瓜多尔" },
            { value: "Egypt +20", label: "埃及" },
            { value: "Estonia +372", label: "爱沙尼亚" },
            { value: "Fiji +679", label: "斐济" },
            { value: "Finland +358", label: "芬兰" },
            { value: "France +33", label: "法国" },
            { value: "French Guiana +594", label: "法属圭亚那" },
            { value: "Gabon +241", label: "加蓬" },
            { value: "Gambia +220", label: "冈比亚" },
            { value: "Georgia +995", label: "格鲁吉亚" },
            { value: "Ghana +233", label: "加纳" },
            { value: "Gibraltar +350", label: "直布罗陀" },
            { value: "Greece +30", label: "希腊" },
            { value: "Guatemala +502", label: "危地马拉" },
            { value: "Guinea +224", label: "几内亚" },
            { value: "Guyana +592", label: "圭亚那" },
            { value: "Haiti +509", label: "海地" },
            { value: "Honduras +504", label: "洪都拉斯" },
            { value: "Iceland +354", label: "冰岛" },
            { value: "India +91", label: "印度" },
            { value: "Iran +98", label: "伊朗" },
            { value: "Iraq +964", label: "伊拉克" },
            { value: "Ireland +353", label: "爱尔兰" },
            { value: "Israel +972", label: "以色列" },
            { value: "Italy +39", label: "意大利" },
            { value: "Japan +81", label: "日本" },
            { value: "Jordan +962", label: "约旦" },
            { value: "Kazakstan +997", label: "哈萨克斯坦" },
            { value: "Kenya +254", label: "肯尼亚" },
            { value: "Korea +82", label: "韩国" },
            { value: "Kuwait +965", label: "科威特" },
            { value: "Kyrgyzstan +996", label: "吉尔吉斯坦" },
            { value: "Laos +856", label: "老挝" },
            { value: "Latvia +371", label: "拉脱维亚" },
            { value: "Lebanon +961", label: "黎巴嫩" },
            { value: "Libya +218", label: "利比亚" },
            { value: "Lithuania +370", label: "立陶宛" },
            { value: "Luxembourg +352", label: "卢森堡" },
            { value: "Malta +356", label: "马耳他" },
            { value: "Mexico +52", label: "墨西哥" },
            { value: "Moldova +373", label: "摩尔多瓦" },
            { value: "Monaco +212", label: "摩纳哥" },
            { value: "Mongolia +976", label: "蒙古" },
            { value: "Nauru +674", label: "瑙鲁" },
            { value: "Nepal +977", label: "尼泊尔" },
            { value: "Netherlands +31", label: "荷兰" },
            { value: "New Zealand +64", label: "新西兰" },
            { value: "Nicaragua +505", label: "尼加拉瓜" },
            { value: "Oman +968", label: "阿曼" },
            { value: "Pakistan +92", label: "巴基斯坦" },
            { value: "Panama +507", label: "巴拿马" },
            { value: "Papua New Cuinea +675", label: "巴布亚新几内亚" },
            { value: "Paraguay +595", label: "巴拉圭" },
            { value: "Peru +51", label: "秘鲁" },
            { value: "Philippines +63", label: "菲律宾" },
            { value: "Portugal +351", label: "葡萄牙" },
            { value: "Qatar +974", label: "卡塔尔" },
            { value: "Reunion +262", label: "留尼旺" },
            { value: "Romania +40", label: "罗马尼亚" },
            { value: "Russia +7", label: "俄罗斯" },
            { value: "Senegal +221", label: "塞内加尔" },
            { value: "Seychelles +248", label: "塞舌尔" },
            { value: "Sierra Leone +232", label: "塞拉利昂" },
            { value: "Singapore +65", label: "新加坡" },
            { value: "Slovakia +421", label: "斯洛伐克" },
            { value: "Slovenia +386", label: "斯洛文尼亚" },
            { value: "Solomon Is +677", label: "所罗门群岛" },
            { value: "South Africa +27", label: "南非" },
            { value: "Spain +34", label: "西班牙" },
            { value: "SriLanka +94", label: "斯里兰卡" },
            { value: "Sudan +249", label: "苏丹" },
            { value: "Suriname +597", label: "苏里南" },
            { value: "Swaziland +268", label: "斯威士兰" },
            { value: "Sweden +46", label: "瑞典" },
            { value: "Switzerland +41", label: "瑞士" },
            { value: "Syria +963", label: "叙利亚" },
            { value: "Tajikstan +992", label: "塔吉克斯坦" },
            { value: "Tanzania +255", label: "坦桑尼亚" },
            { value: "Thailand +66", label: "泰国" },
            { value: "Togo +228", label: "多哥" },
            { value: "Tonga +676", label: "汤加" },
            { value: "Tunisia +216", label: "突尼斯" },
            { value: "Turkey +90", label: "土耳其" },
            { value: "Turkmenistan +993", label: "土库曼斯坦" },
            { value: "Uganda +256", label: "乌干达" },
            { value: "Ukraine +380", label: "乌克兰" },
            { value: "United Arab Emirates +971", label: "阿拉伯联合酋长国" },
            { value: "United Kiongdom +44", label: "英国" },
            { value: "Uruguay +598", label: "乌拉圭" },
            { value: "Uzbekistan +998", label: "乌兹别克斯坦" },
            { value: "Venezuela +58", label: "委内瑞拉" },
            { value: "Vietnam +84", label: "越南" },
            { value: "Yemen +967", label: "也门" },
            { value: "Zimbabwe +263", label: "津巴布韦" },
            { value: "Zambia +260", label: "赞比亚" }
          ]
        }
      ]
    };
  },
  mounted() {
    this.formData = this.countryId
  },
  watch: {
    formData() {
      this.$emit("country", this.formData);
    }
  }
};
</script>

<style>
.groupBlue {
  background-color: #00355d;

  width: 170px;
}
.selectBlue .el-input .el-input__inner {
  background-color: #00355d;
  border: none;
  width: 170px;
}
.groupBlack {
  width: 170px;
}
.selectBlack .el-input .el-input__inner {
  border: none;
  width: 170px;
}
.groupWhite {
  background-color: #d9d9d9;
  width: 170px;
}
.selectWhite .el-input .el-input__inner {
  border: none;
  background-color: #d9d9d9;
  width: 170px;
}
</style>




// WEBPACK FOOTER //
// src/components/foreignArea.vue